import { iChainMenuItems } from "@apiHooks/useChainsMenuItems";

export const NO_INCLUDE_TERMS_MESSAGE =
    "Add at least one Include term to get the featuring menu items to show up";

export function intersectByChainIds(
    rows: iChainMenuItems[],
    chainIds: number[],
): iChainMenuItems[] {
    const allowed = new Set(chainIds);
    return rows.filter(row => row.chainId != null && allowed.has(row.chainId));
}
